import React from 'react';
import { useIntl } from 'react-intl';
import {
  FieldArrayRenderProps,
  useField,
} from 'formik';

import * as types from 'hellospa/page/prep-and-send/data/types';
import messages from './intl';

import Row from './row';
import { DragSort } from 'hellospa/components/drag-sort';
import { unreachable } from 'hellospa/ts-utils';

type RecipientRowsProps = {
  helper: FieldArrayRenderProps,
}

const RecipientRows = ({ helper }: RecipientRowsProps) => {
  const intl = useIntl();

  const [recipientsField] = useField<types.Recipient[]>('recipients');

  return (
    <DragSort
      component={Row}
      onDrop={(drop) => helper.move(drop.from, drop.to)}
      data={recipientsField.value}
      messageValues={(recipient) => {
        switch (recipient.type) {
          case types.RecipientTypes.Signer:
            return {
              name: recipient.name,
              type: intl.formatMessage(messages.signerType),
            };
          case types.RecipientTypes.Role:
            return {
              name: recipient.name,
              type: intl.formatMessage(messages.roleType),
            };
          // These types aren't really needed here because they
          // don't use a signer order and can't be sorted.
          case types.RecipientTypes.Fax:
            return { name: '', type: '' };
          default:
            unreachable(recipient);
            return { name: '', type: '' };
        }
      }}
      getProps={(recipient, index) => ({
        key: recipient.id,
        recipient,
        index,
        formikHelpers: helper,
      })} />
  );
};


export default RecipientRows;
